import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BaseQueryParams, IResponse, IResponsePaginate } from '@/types';
import { Observable } from 'rxjs';

interface SeuilGlobal {
  id: number;
  typeMarcherId: number;
  montant: number;
  typeMarcher?: {
    id: number;
    description: string;
  };
}

interface SeuilGlobalDto {
  typeMarcherId: number;
  montant: number;
}

interface SeuilGlobalQuery extends BaseQueryParams {
  typeMarcherId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SeuilsGlobalService {
  private httpClient = inject(HttpClient);
  private BASEURL = `${environment.api.paramsUrl}`;

  getSeuils(params?: SeuilGlobalQuery): Observable<IResponsePaginate<SeuilGlobal>> {
    let httpParams = new HttpParams();

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }

    return this.httpClient.get<IResponsePaginate<SeuilGlobal>>(`${this.BASEURL}/seuil-general`, { params: httpParams });
  }

  addSeuil(seuil: SeuilGlobalDto): Observable<IResponse<SeuilGlobal>> {
    return this.httpClient.post<IResponse<SeuilGlobal>>(`${this.BASEURL}/seuil-general`, seuil);
  }

  updateSeuil(id: number, seuil: SeuilGlobalDto): Observable<IResponse<SeuilGlobal>> {
    return this.httpClient.put<IResponse<SeuilGlobal>>(`${this.BASEURL}/seuil-general/${id}`, seuil);
  }

  deleteSeuil(id: number): Observable<IResponse<void>> {
    return this.httpClient.delete<IResponse<void>>(`${this.BASEURL}/seuil-general/${id}`);
  }
}
